import React from "react";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";
import Spotlight from "../components/Spotlight";

const PartnerPage = () => (
    <PageLayout title="Partner · IndoBlitz" testId="partner-page">
        <PageHero
            eyebrow="Partner"
            title="Open lanes for"
            accent="partners."
            intro="Independent BD partners, agencies and consultants - open a commercial lane in Sydney, Dubai, London, Singapore and beyond. Sell urban-IT quality at India economics, and earn long-term referral revenue."
            testId="partner-hero"
        />
        <Spotlight />
    </PageLayout>
);

export default PartnerPage;
